import React from 'react';
import { connect } from 'react-redux';
import mapStateToProps from 'reducers/actions/stateToProps';
import './layoutstyle.css';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import { AccountHandler } from 'chits-data/dist';
import i18n from 'i18n';
import Constants from 'components/utils/constants';
let translations = {
    te: {
        Accounts: "మీ చిట్టీలు",
        Info: "చిట్టీ సమాచారం",
        Manage: "చిట్టీ నడుపు",
        Members: "చిట్టీ సభ్యులు",
        Transactions: "చిట్టీ పాటలు",
        Payments: "చెల్లింపులు",
        Statements: "రసీదులు"
    }
}
let console = Constants.consoleWrapper(false);
let t = (s) => (!i18n.language || i18n.language === "en") ? s : translations[i18n.language][s];

let path = window.location.pathname.toLowerCase();
class SideBar extends React.Component {

    constructor(props) {
        super(props);
        // this._handler = new AccountHandler();
    }

    prepareItem = (item) => {
        let { current } = this.props.wallet;
        // Highlight an appropriate item based on the current url
        let active = false;
        // Since accounts is default page; highlight either way.
        if (path === "/" && item.path === "/accounts")  {
            active = true;
        }
        // Activate any absolute matched paths
        if (path === item.path) {
            active = true;
        }
        // If the page is a sub page of /accounts/ 
        else if (item.path.startsWith('/accounts/') && path.startsWith(item.path)) {
            active = true;
        }
        // If an active account is present replace the name with account name
        let newName = (item.name === "Accounts" && current.name!=="unknown") ? current.name : t(item.name);
        return (
            <li key={item.name} className={`nav-item ${active ? 'active' : ''} `}>
                <a className="nav-link" href={item.path}>
                    <i className={`nc-icon ${item.icon} icon-bold ${item.level ? 'level' + item.level : 'level1'}`}></i>
                    <p>{newName}</p>
                </a>
            </li>
        );
    }

    render() {
        let { current } = this.props.wallet;
        console.debug('this.props.wallet.current', this.props.wallet.current)
        // console.debug('this.state.account', this.state.account)

        let subCnt = 0;
        try {
            if (current && current.subscribers)
                subCnt = Object.keys(current.subscribers).length;
            console.debug('subCnt', subCnt);
        } catch (error) {
            console.error(error)
        }

        let { chit_info } = current;
        let {
          chit_amount,
          chit_draw_date,
          chit_due,
          chit_start_on,
          chit_subscribers,
          chit_tenure,
          chit_term_amount,
          chit_term_fee,
          nextTerm
        } = chit_info;

        // if term = -1; chit matured
        // if term > 1; chit is active
        // if term = 1; chit is inactive
        // if term = undefined; chit not  yet started
        let chitNew = nextTerm === undefined;
        let chitInitiated = !chitNew && nextTerm === 1;
        let chitActive = !chitNew && nextTerm > 1;
        let chitMatured = !chitNew && nextTerm === -1;
        console.debug('chitNew', chitNew);
        console.debug('chitInitiated', chitInitiated);
        console.debug('chitActive', chitActive);
        console.debug('chitMatured', chitMatured);

        let navItems = [
            {
                name: "Accounts",
                path: '/accounts',
                icon: 'nc-bank',
            },
        ];

        if (this.props.wallet.current._id !== "default") {
            navItems.push(
                {
                    name: "Info",
                    path: '/info',
                    icon: 'pe-7s-info',
                    level: 2,
                },
                {
                    name: "Manage",
                    path: '/manage',
                    icon: 'nc-preferences-circle-rotate',
                    level: 2,
                },
            )
        }

        if (subCnt > 0) {
            navItems.push(
                {
                    name: "Members",
                    path: '/members',
                    icon: 'pe-7s-id',
                    level: 2,
                },
            )
        }

        if (chitActive || chitMatured) {
            navItems.push(
                {
                    name: "Transactions",
                    path: '/transactions',
                    icon: 'nc-paper-2',
                },
                {
                    name: "Payments",
                    path: '/payments',
                    icon: 'nc-money-coins',
                },
                {
                    name: "Statements",
                    path: '/statements',
                    icon: 'pe-7s-print',
                },
            )
        }

        return (
            <div className="sidebar"
                data-image="/assets/img/sidebar-2.jpg" >
                <div className="sidebar-wrapper">
                    <ul className="nav">
                        {navItems.map((item) => {
                            return this.prepareItem(item)
                        })}
                    </ul>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <div className="footer" style={{ fontSize: 'smaller' }}>
                        Version: {process.env.REACT_APP_VERSION}<br />
                        ViewPort: {this.props.appState.width}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);